// ©️ كليشة حقوق تصاميم أرتيكا - تطلع بكل شي يوصل للزبون: الفاتورة (صورتها
// وملف الـPDF وصفحات اللوحات بيه)، وعرض السعر (صفحات اللوحات المقترحة + صفحة
// "تواصل معنا"). أي تعديل على النص هنا ينعكس بكل الأماكن.
// النشر على السوشيل ميديا مسموح - الممنوع الطباعة والنسخ وإعادة الإنتاج.

export const COPYRIGHT_TITLE = "حقوق التصميم محفوظة لأرتيكا";

export const COPYRIGHT_TEXT =
  "جميع تصاميم أرتيكا ولوحاتها ملكية فكرية محفوظة للشركة، ويُمنع طباعتها أو نسخها أو إعادة إنتاجها بأي شكل دون موافقة خطية مسبقة من أرتيكا، وخلاف ذلك يعرّض صاحبه للمساءلة القانونية.";

// سطر قصير لصفحات اللوحات بعرض السعر (ما يزحم التصميم)
export const COPYRIGHT_SHORT = "تصاميم أرتيكا محفوظة الحقوق - يُمنع طباعتها أو نسخها دون موافقة الشركة";

// السنة من تاريخ الفاتورة (حتى ما تتغير الفواتير القديمة)، وإلا السنة الحالية
export const copyrightYear = (date) => {
  const year = new Date(date || Date.now()).getFullYear();
  return Number.isFinite(year) ? year : new Date().getFullYear();
};

export const copyrightLineEn = (year) =>
  `© ${year} Artika. All Artika designs are protected. Printing, copying or reproduction without written permission is prohibited.`;
